import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "./radio.css";
import "./index.css";
import * as serviceWorker from "./Util/serviceWorker.js";
import router from "./router";

ReactDOM.render(router, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
